import React from "react";

// mui imports
import { Box, Divider, Typography } from "@mui/material";
import FooterUpper from "./FooterUpper";
import FooterLower from "./FooterLower";

export default function Footer() {
  return (
    <Box className="lg:px-[3rem] lg:py-[3rem] py-[2rem] px-[1rem]">
      <FooterUpper />
      <Divider className="my-[30px] bg-primary h-[0.7px] border-none" />
      <FooterLower />
    </Box>
  );
}
